export const CompanyType = Object.freeze({
  Enterprise: 1,
  Management: 2,
});
export const CompanyTypeExpanded = {
  Enterprise: {
    value: CompanyType.Enterprise,
    text: 'Enterprise',
    color: 'green accent-3',
    textColor: 'darkGrey-2',
    icon: 'mdi-office-building-outline',
  },
  Management: {
    value: CompanyType.Management,
    text: 'Management',
    color: 'primary',
    textColor: 'darkGrey-2',
    icon: 'mdi-wrench',
  },
};

export const TaskFieldType = Object.freeze({
  Text: 1,
  Number: 2,
  Boolean: 3,
  Date: 4,
  Users: 7,
  Dropdown: 6,
  Plan3D: 8,
  // Time: 7,
});

export const taskFieldList = Object.keys(TaskFieldType).map((key) => ({
  text: key,
  value: TaskFieldType[key],
}));

export const TaskGroupProps = {
  'Project.ContractId': 'contractId',
  'ProjectId': 'projectId',
  'Project.ProjectManagerId': 'projectManagerId',
  'Project.WBSElementId': 'wbsElementId',
  'ReportedById': 'reportedById',
  'ApprovedById': 'approvedById'
}



export const NotificationType = Object.freeze({
  TaskAssigned: 10001,
  TagImportCompleted: 10002,
  ApiDataPullCompleted: 10003,
  ApiDataPullFailed: 10004,
  ReleasePublished: 10005,
});

export const EventTypes = [
  { id: 1, name: 'Meeting' },
  { id: 2, name: 'Deadline' },
  { id: 3, name: 'Reminder' },
  { id: 4, name: 'Workshop' },
  { id: 5, name: 'Conference' },
  { id: 6, name: 'Task' },
]

export const FrequencyType = [
  { id: 0, name: 'None' },
  { id: 1, name: 'Daily' },
  { id: 2, name: 'Weekly' },
  { id: 3, name: 'Monthly' },
  { id: 4, name: 'Yearly' },
]

export const RecurrenceType = [
  { id: 0, name: 'Do not repeat' },
  { id: 1, name: 'Day' },
  { id: 2, name: 'Week' },
  { id: 3, name: 'Month' },
  { id: 4, name: 'Year' },
]

export const AnomalyCondition = Object.freeze({
  Normal: 1,
  Caution: 2,
  Warning: 3,
  Critical: 4,
})

/**
 * The unset value of a tag's `condition`, mirroring the server enum member
 * `Condition.None` (`MODS.Forge.Models` `Condition.cs`, None = 0).
 *
 * `AnomalyCondition` above intentionally has no 0 member: it feeds the condition
 * dropdowns, and "None" is not a choice a user picks. So the neutral default a
 * tag constructor sends to the API lives here instead. It must never be `null` —
 * the API binds `Condition` as a non-nullable enum and a null 400s the write
 * (AVA-492).
 */
export const TAG_CONDITION_NONE = 0

/**
 * Enum for logo variants used across the application
 * @readonly
 * @enum {number}
 */
export const LogoVariant = Object.freeze({
  COLORED: 1,
  WHITE: 2,
  BLACK: 3
});
